import { render } from "./TransactionDialog.vue?vue&type=template&id=65118369&scoped=true&ts=true"
import script from "./TransactionDialog.vue?vue&type=script&lang=ts"
export * from "./TransactionDialog.vue?vue&type=script&lang=ts"

import "./TransactionDialog.vue?vue&type=style&index=0&id=65118369&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65118369"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
